/**
 * Session-storage helpers for the gallery "Load from file" → editor flow.
 * The gallery stages scene JSON, navigates to /?import=1, and the editor
 * consumes it on mount (one-shot read + clear).
 */

const IMPORT_SCENE_KEY = "excalidraw-ms:import-scene";

/** Stage an imported scene for the editor to pick up on mount. */
export function stageImportedScene(sceneJSON: string): void {
  sessionStorage.setItem(IMPORT_SCENE_KEY, sceneJSON);
}

/** Consume a staged imported scene (one-shot — clears after read). */
export function consumeImportedScene(): string | null {
  const scene = sessionStorage.getItem(IMPORT_SCENE_KEY);
  if (scene) sessionStorage.removeItem(IMPORT_SCENE_KEY);
  return scene;
}

/** Discard an imported scene and report whether its absence was confirmed. */
export function clearStagedImportedScene(): boolean {
  try {
    sessionStorage.removeItem(IMPORT_SCENE_KEY);
    return sessionStorage.getItem(IMPORT_SCENE_KEY) === null;
  } catch {
    return false;
  }
}
